import * as React from 'react';
import { connect } from 'react-redux';

import {getPointByTeamId} from '../reducers/statsRanking';
import {getActiveChannelId} from "../reducers/gui";
import {getMatchIdByChannelId} from "../reducers/timings";
import {getPlayerUidsByMatchId} from "../reducers/matches";
import {getRankAccordingToPlayerId} from "../reducers/statsRanking";

import {
    getStaticText
} from "../reducers/staticTexts";

import { getTranslations } from "../reducers/translations";

import PlayerPointsPresentation from '../presentations/PlayerPoints/PlayerPointsPresentation';

const mapStateToProps = ( state: any, ownProps: { channelId?: number } ) => {

    const activeChannelId: number = getActiveChannelId( state );
    const channelId: number = ownProps.channelId ? ownProps.channelId : activeChannelId;
    const matchId = getMatchIdByChannelId( state, channelId );
    const ranksByPlayerIds = getRankAccordingToPlayerId( state );
    const playerUids = getPlayerUidsByMatchId( state, matchId );

    return {
        displayName: '',
        staticTexts: getStaticText( state ),
        translations: getTranslations( state ),
        activeChannelId: activeChannelId,
        clubIds: getPlayerUidsByMatchId(state, matchId),
        pointsHome: ranksByPlayerIds && ranksByPlayerIds[playerUids['home']] ? ranksByPlayerIds[playerUids['home']].points : null,
        pointsAway: ranksByPlayerIds && ranksByPlayerIds[playerUids['away']] ? ranksByPlayerIds[playerUids['away']].points : null,
    }
};

export default connect(mapStateToProps)(PlayerPointsPresentation);